import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductCardSkeletonComponent } from '../../../../../shared/ui/product-card-skeleton/product-card-skeleton.component';

@Component({
  selector: 'app-product-detail-skeleton',
  imports: [ProductCardSkeletonComponent],
  templateUrl: './product-detail-skeleton.component.html',
  styleUrl: './product-detail-skeleton.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailSkeletonComponent {
  protected readonly carouselSkeletons = Array(5);
}
